import {takeEvery} from 'redux-saga/effects'
import {
  SP_HOME_GET_ACCESS_STATUS,
  SP_HOME_GET_ECARD_PROFILE,
  SP_HOME_GET_ECARD_QR,
  SP_HOME_GET_FEED,
  SP_HOME_GET_LECTURES,
  SP_HOME_GET_OWN_PROFILE,
  SP_HOME_GET_STATS,
  SP_HOME_GET_SUBJECTS,
  SP_HOME_GET_TODAY_ATTENDANCE,
  SP_HOME_GET_TODAY_SUBJECT_ATTENDANCE,
} from 'setup/redux/Actions/StudentHome/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

/** Student/parent dashboard (mobile home APIs) and the fee-defaulter lock. */
function* studentHomeSagas() {
  yield takeEvery(SP_HOME_GET_STATS, fetchData)
  yield takeEvery(SP_HOME_GET_FEED, fetchData)
  yield takeEvery(SP_HOME_GET_SUBJECTS, fetchData)
  yield takeEvery(SP_HOME_GET_LECTURES, fetchData)
  yield takeEvery(SP_HOME_GET_TODAY_ATTENDANCE, fetchData)
  yield takeEvery(SP_HOME_GET_TODAY_SUBJECT_ATTENDANCE, fetchData)
  yield takeEvery(SP_HOME_GET_ACCESS_STATUS, fetchData)
  yield takeEvery(SP_HOME_GET_ECARD_PROFILE, fetchData)
  yield takeEvery(SP_HOME_GET_ECARD_QR, fetchData)
  yield takeEvery(SP_HOME_GET_OWN_PROFILE, fetchData)
}

export default studentHomeSagas
